import React, { useState } from 'react';
import PublicationCard from '../components/PublicationCard';
import Contact from '../sections/Contact';

interface Publication {
  title: string;
  authors: string;
  // journal: string;
  year: number;
  link: string;
  featured?: boolean;
}


const Publications = () => {
  const allPublications: Publication[] = [
    {
      title: "The Engineered Drug 3′UTRMYC1-18 Degrades the c-MYC-STAT5A/B-PD-L1 Complex In Vivo to Inhibit Metastatic Triple-Negative Breast Cancer",
      authors: "Chidiebere U. Awah 1,2,*Joo Sun Mun3,Aloka Paragodaarachchi 3,4,Baris Boylu 1,Chika Ochu1,Hiroshi Matsui3,5,6 and Olorunseun O. Ogunwobi1,2,7",
      // journal: "Journal of Medicinal Chemistry",
      year: 2021,
      link: "https://www.mdpi.com/2072-6694/16/15/2663",
      featured: true
    },
    {
      title: "Destabilized 3’UTR ARE therapeutically degrades ERBB2 in drug-resistant ERBB2+ cancer models.",
      authors: "Awah CU*+, Glemaud Y, Levine F, Yang K, Ansary A, Dong F, Ash L, Zhang J, Ogunwobi OO+.",
      // journal: "Nature Communications",
      year: 2022,
      link: "https://doi.org/10.1101/2022.08.14.503914",
      featured: true
    },
    {
      title: "Engineered destabilized AU rich elements on the 3UTR of HER2 degrades HER2, inhibits proliferation, and induces apoptosis in HER2 positive trastuzumab resistant breast cancer cells.",
      authors: "ChidiebereU.Awah*,Fu Dong,Fayola Levine, Leonard Ash,Yana Glemaud,Olorunseun Ogunwobi",
      // journal: "Cell Reports",
      year: 2022,
      link: "https://aacrjournals.org/cancerres/article/82/12_Supplement/1788/701857/Abstract-1788-Engineered-destabilized-AU-rich",
      featured: true
    },
    {
      title: "Engineered destabilized ARE on the 3UTR of MYC degrades oncogenic c-MYC transcript and protein and induces apoptosis in multiple cancer type",
      authors: "Chidiebere Awah*,Fu Dong,Yana Glemaud,Fayola Levine,Olorunseun Ogunwobi",
      // journal: "Cell Reports",
      year: 2022,
      link: "https://aacrjournals.org/cancerres/article/82/12_Supplement/1809/702949/Abstract-1809-Engineered-destabilized-ARE-on-the",
      featured: true
    },
    {
      title: "Effect of Engineered Destabilized HER2 3'UTR ARE on the Proliferation of HER2+ Trastuzumab Resistant Breast Cancer Cells",
      authors: "Awah CU*+, Ansary A, Glemaud Y, Levine F, Ogunwobi OO",
      // journal: "Cell Reports",
      year: 2022,
      link: "https://www.researchgate.net/publication/360554499_Effect_of_Engineered_Destabilized_HER2_3'UTR_ARE_on_the_Proliferation_of_HER2_Trastuzumab_Resistant_Breast_Cancer_Cells?_sg%5B0%5D=wpYZCXtfA08s_6AqFLwoPhXcd0piAUrT0phoRxD6ulaXAZIr0WMeG40PEMqHkA9c0dMyc9NCAc-RjA3qS8ts3UDF5ILCmt7dRq0dsRZU.DaKSi4CNPDITNwpxdo9tEHIh107a3mJBdm2GpM1assCWzmfC-XnN7nCbZ9KDzol1e70Et7nHci0VkhOUkcdqBg",
      featured: true
    },
    {
      title: "Engineered Destabilized HER2 3'UTR ARE as Novel Therapeutics for EGFR T790M and HER2 mutated NSCLC",
      authors: "5. Awah CU*+, Glemaud Y, Ansary A,  Levine F, Ogunwobi OO",
      // journal: "Cell Reports",
      year: 2022,
      link: "https://www.researchgate.net/publication/360554265_Engineered_Destabilized_HER2_3'UTR_ARE_as_Novel_Therapeutics_for_EGFR_T790M_and_HER2_mutated_NSCLC",
      featured: true
    },
    {
      title: "Destabilized 3’UTR ARE therapeutically degrades ERBB2 in drug-resistant ERBB2+ cancer models",
      authors: "Chidiebere U Awah, Yana Glemaud, Fayola Levine, Kiseok Yang, Afrin Ansary, Fu Dong, Leonard Ash, Junfei Zhang, Daniel Weiser, Olorunseun O Ogunwobi",
      // journal: "Cell Reports",
      year: 2022,
      link: "https://www.biorxiv.org/content/10.1101/2022.08.14.503914v1.full",
      featured: true
    },
    {
      title: "Nanocage delivered engineered destabilized HER2 3UTR ARE reduced growth of primary EGFR T790M HER2 overexpressing osimertinib and trastuzumab resistant non small cell lung cancer and inhibited liver and lung metastasis in vivo",
      authors: "Chidiebere U. Awah;Joo Sun Mun;Baris Boylu;Alooka Paragodaarachchi;Chika Ochu;Junfei Zhang;Hiroshi Matsui;Olorunseun O. Ogunwobi",
      // journal: "Cell Reports",
      year: 2022,
      link: "https://aacrjournals.org/cancerres/article/83/7_Supplement/3417/720182",
      featured: true
    },
    {
      title: "In vivo inhibition of metastatic HER2 positive trastuzumab resistant breast cancer using engineered destabilized 3UTR ARE of HER2 improves survival outcomes",
      authors: "Chidiebere U. Awah; Joo Sun Mun; Baris Boylu; Alooka Paragodaarachchi; Chika Ochu; Junfei Zhang; Hiroshi Matsui; Olorunseun O. Ogunwobi.",
      // journal: "Cell Reports",
      year: 2023,
      link: "https://aacrjournals.org/cancerres/article/83/7_Supplement/3900/723210",
      featured: true
    },
    {
      title: "Targeting cMYC in metastatic castration resistant and neuroendocrine prostate cancer",
      authors: "Chidiebere U. Awah; Olorunseun O. Ogunwobi.",
      // journal: "Cell Reports",
      year: 2023,
      link: "https://aacrjournals.org/cancerres/article/83/7_Supplement/4504/723174",
      featured: true
    },
    {
      title: "Nanocage delivered engineered destabilized 3UTR ARE of cMYC inhibits triple negative breast cancer growth and metastasis in vivo by targeting cMYC and downregulating STAT5A5B",
      authors: "Chidiebere U. Awah; Joo Sun Mun; Baris Boylu; Alooka Paragodaarachchi; Chika Ochu; Junfei Zhang; Hiroshi Mastui; Olorunseun Ogunwobi. Cancer Res (2023) 83 (7_Supplement): 1459.",
      // journal: "Cell Reports",
      year: 2023,
      link: "https://aacrjournals.org/cancerres/article/83/7_Supplement/1459/723438",
      featured: true
    },
    {
      title: "Destabilized 3’UTR elements therapeutically degrade ERBB2 mRNA in drug-resistant ERBB2+ cancer models",
      authors: "Chidiebere U. Awah1,2*, Yana Glemaud1, Fayola Levine1,2, Kiseok Yang1, Afrin Ansary1, Fu Dong1, Leonard Ash1, Junfei Zhang3 and Olorunseun O. Ogunwobi1",
      // journal: "Cell Reports",
      year: 2023,
      link: "https://www.frontiersin.org/journals/genetics/articles/10.3389/fgene.2023.1184600/full",
      featured: true
    },
    {
      title: "Nanocage-incorporated engineered destabilized 3'UTR ARE of ERBB2 inhibits tumor growth and liver and lung metastasis in EGFR T790M osimertinib- and trastuzumab-resistant and ERBB2-expressing NSCLC via the reduction of ERBB2",
      authors: "Chidiebere U. Awah1,2*Joo Sun Mun3Aloka Paragodaarachchi3,4Baris Boylu1Martin Nzegwu5Hiroshi Matsui3,4,6,7Olorunseun Ogunwobi1,2,8*",
      // journal: "Cell Reports",
      year: 2024,
      link: "https://www.frontiersin.org/journals/oncology/articles/10.3389/fonc.2024.1344852/full",
      featured: true
    },
    {
      title: "Abstract 3039: Pan cancer therapeutic inhibition of oncogenic c-MYC by the engineered destabilized 3’UTR of c-MYC ",
      authors: "Chidiebere U. Awah",
      // journal: "Cell Reports",
      year: 2024,
      link: "https://aacrjournals.org/cancerres/article/84/6_Supplement/3039/738749",
      featured: true
    },
    {
      title: "Abstract 5590: Engineered destabilized 3’UTR of TEAD1 therapeutically inhibits and degrades TEAD1 mRNA and YAP1 interactors across multiple cancers",
      authors: "Chidiebere U. Awah",
      // journal: "Cell Reports",
      year: 2024,
      link: "https://aacrjournals.org/cancerres/article/84/6_Supplement/5590/741736",
      featured: true
    },
       {
      title: "In vivo inhibition of c-MYC in the metastatic drug-resistant ovarian cancer cells down regulates the c-MYC-PD-L1-PAX8-p21 to achieve therapeutic efficacy",
      authors: "Queenie Chen, Jigme P. Dorji, Sandali G. Perera, Petvy Li, Fizza Aijaz, Linda C. Ihuoma, Hiroshi Matsui & Chidiebere U. Awah",
      // journal: "Cell Reports",
      year: 2025,
      link: "https://link.springer.com/article/10.1186/s12885-025-15435-8",
      featured: true
    },
    {
      title: "c-MYC mRNA destabilization inhibited lethal pancreatic cancer in vivo with significant survival outcomes",
      authors: "Jigme P. Dorji, Queenie Chen, Sandali G. Perera, Fizza Aijaz, Petvy Li, Tanjina Sania, Hiroshi Matsui2,3,4,5 Chidiebere U. Awah",
      // journal: "Cell Reports",
      year: 2025,
      link: "https://www.frontiersin.org/journals/pharmacology/articles/10.3389/fphar.2025.1630476/full",
      featured: true
    }
 
    // Add more publications as needed
  ].sort((a, b) => b.year - a.year); // Sort by year descending

   // Pagination states
  const [featuredPage, setFeaturedPage] = useState(1);
  // eslint-disable-next-line no-empty-pattern
  const [] = useState(1);
  const itemsPerPage = 6;

  // Filter publications
  const featuredPublications = allPublications.filter(pub => pub.featured);

  // Pagination logic
  const featuredStartIndex = (featuredPage - 1) * itemsPerPage;
  const featuredEndIndex = featuredStartIndex + itemsPerPage;
  const visibleFeatured = featuredPublications.slice(featuredStartIndex, featuredEndIndex);
  const totalFeaturedPages = Math.ceil(featuredPublications.length / itemsPerPage);


  // Pagination controls component
  const PaginationControls = ({
    currentPage,
    totalPages,
    onPageChange
  }: {
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void;
  }) => (
    <div className="flex justify-center mt-6 space-x-2">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="px-3 py-1 rounded-md bg-gray-200 text-gray-700 disabled:opacity-50"
      >
        Previous
      </button>
      
      {Array.from({ length: totalPages }, (_, i) => (
        <button
          key={i + 1}
          onClick={() => onPageChange(i + 1)}
          className={`px-3 py-1 rounded-md ${currentPage === i + 1 ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700'}`}
        >
          {i + 1}
        </button>
      ))}
      
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="px-3 py-1 rounded-md bg-gray-200 text-gray-700 disabled:opacity-50"
      >
        Next
      </button>
    </div>
  );

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <div className="flex-grow py-36 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Page Header */}
          <div className="text-center mb-12">
            <h1 className="text-4xl font-extrabold text-gray-900 sm:text-5xl sm:tracking-tight lg:text-6xl">
              Our Publications
            </h1>
          </div>

          {/* Featured Publications with Pagination */}
          {featuredPublications.length > 0 && (
            <div className="mb-16">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">All Publications</h2>
              <div className="grid gap-8 md:grid-cols-2">
                {visibleFeatured.map((pub, index) => (
                  <PublicationCard 
                    key={`featured-${index}`} 
                    publication={pub} 
                    isFeatured={true} 
                  />
                ))}
              </div>
              <PaginationControls
                currentPage={featuredPage}
                totalPages={totalFeaturedPages}
                onPageChange={setFeaturedPage}
              />
            </div>
          )}

          {/* Regular Publications with Pagination */}
          {/* <div className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">All Publications</h2>
            <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
              {visibleRegular.map((pub, index) => (
                <PublicationCard 
                  key={`regular-${index}`} 
                  publication={pub} 
                  isFeatured={false} 
                />
              ))}
            </div>
            <PaginationControls
              currentPage={regularPage}
              totalPages={totalRegularPages}
              onPageChange={setRegularPage}
            />
          </div> */}

          {/* Submission Info */}
          {/* <div className="mt-8 bg-blue-50 p-6 rounded-lg">
            <h3 className="text-lg font-medium text-blue-800 mb-3">Submit Your Research</h3>
            <p className="text-gray-700">
              Contact: <a href="mailto:research@utrtherapeutics.com" className="text-blue-600 hover:underline">
                research@utrtherapeutics.com
              </a>
            </p>
          </div> */}
        </div>
      </div>

      <div className="w-full">
        <Contact />
      </div>
    </div>
  );
};

export default Publications;